import { render } from "./NovaMaisView.vue?vue&type=template&id=a4948e5c"
import script from "./NovaMaisView.vue?vue&type=script&lang=js"
export * from "./NovaMaisView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__